// src/components/admin/SettingsAdmin.js
import React, { useState } from 'react';
import DeleteClassTab from './settings/DeleteClassTab';
import ModifyDataTab from './settings/ModifyDataTab';
import UsersTab from './settings/UsersTab';

const SettingsAdmin = () => {
  const [activeTab, setActiveTab] = useState('delete');

  const renderTab = () => {
    switch (activeTab) {
      case 'delete':
        return <DeleteClassTab />;
      case 'modify':
        return <ModifyDataTab />;
      case 'users':
        return <UsersTab />;
      default:
        return null;
    }
  };

  const tabStyle = isActive => ({
    color: isActive ? 'var(--primary-color)' : 'var(--text-color)',
    borderBottom: isActive ? '2px solid var(--primary-color)' : 'none',
  });

  return (
    <div
      className="container mx-auto mt-4 px-4 py-4 rounded"
      style={{
        backgroundColor: 'var(--section-bg)',
        color: 'var(--text-color)',
      }}
    >
      <h2 className="text-2xl font-bold mb-4">Admin Settings</h2>

      {/* Tabs */}
      <ul
        className="flex border-b mb-4"
        role="tablist"
        style={{ borderColor: 'var(--muted-color)' }}
      >
        <li>
          <button
            role="tab"
            onClick={() => setActiveTab('delete')}
            className="cursor-pointer py-2 px-4 transition-colors duration-200"
            style={tabStyle(activeTab === 'delete')}
          >
            Delete Class
          </button>
        </li>
        <li>
          <button
            role="tab"
            onClick={() => setActiveTab('modify')}
            className="cursor-pointer py-2 px-4 transition-colors duration-200"
            style={tabStyle(activeTab === 'modify')}
          >
            Modify Data
          </button>
        </li>
        <li>
          <button
            role="tab"
            onClick={() => setActiveTab('users')}
            className="cursor-pointer py-2 px-4 transition-colors duration-200"
            style={tabStyle(activeTab === 'users')}
          >
            Users
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="mt-3">{renderTab()}</div>
    </div>
  );
};

export default SettingsAdmin;
